<template>
  <div class="errorHelp">
    <NavHeaderBar title="异常" rightArrow />
    <Default :imgurl="type" text="网络异常" :errorHelp="true">
      <div class="eh-btn">
        <button class="eh-shua" @click="goReload">刷新一下</button>
        <button class="eh-yuan" @click="goPhone">联系管理员</button>
      </div>
    </Default>
  </div>
</template>

<script>
import { ServicePhone } from "@/config/consts";
import { routerReplace } from "@/config/locationRouter";
import { goPhone } from "@/config/utils";
export default {
  name: "ErrorHelp",
  data() {
    return {
      type: "network"
    };
  },
  methods: {
    goReload() {
      routerReplace({ path: this.$route.query.fullPath });
    },
    goPhone() {
      goPhone(ServicePhone);
    }
  }
};
</script>

<style lang="scss">
.errorHelp {
  overflow: hidden;
  .van-empty__description {
    /* margin-top: 0; */
    .default {
      .custom-image {
        .van-empty__image {
          width: 187px;
          height: 172px;
        }
      }
    }
  }
  .eh-btn {
    display: flex;
    flex-direction: column;
    .eh-shua {
      width: 109px;
      height: 31px;
      background: #2291f2;
      border-radius: 16.5px;
      border: none;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 17.5px;
    }
    .eh-yuan {
      width: 109px;
      height: 31px;
      background: #fff;
      color: #1ab576;
      border: none;
    }
  }
}
</style>
